import { BRANDS, BrandedFooter, footerContent as plasticFooterContent } from '@cof/plastic-components';

import partners from '../../partners';
import pushToDataLayer, { EVENTS } from '../../utilities/dataLayer';
import useQueryParams from '../../utilities/useQueryParams';
import { addSParameterToLinkUrl } from '../../utilities/utils';

const Footer = () => {
    const { sParameter } = useQueryParams();
    const footerContent = Object.entries(plasticFooterContent).reduce((updatedFooter, [footerBrand, content]) => {
        // @ts-expect-error TS18048: 'content' is possibly 'undefined'.
        const updatedLinks = content.links.map((link: any) => ({
            ...link,
            url: addSParameterToLinkUrl({ url: link.url, sParameter }),

            onClick: () => {
                pushToDataLayer({ event: EVENTS.FOOTER_LINK_CLICK, footerLinkName: link.text });
            }
        }));
        return {
            ...updatedFooter,
            [footerBrand === BRANDS.CAPITAL_ONE ? partners.DEFAULT : footerBrand.toLowerCase()]: {
                links: updatedLinks,
                // @ts-expect-error TS18048: 'content' is possibly 'undefined'.
                copyright: content.copyright
            }
        };
    }, {});

    // @ts-expect-error TS2322: Type 'null' is not assignable to type 'string[] | undefined'.
    return <BrandedFooter allowList={null} footerContent={footerContent} />;
};

export default Footer;
